import { DocumentationLegacyItemConfiguration, } from "./configuration/SDKDocumentationLegacyItemConfiguration";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocumentationLegacyItem {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b, _c;
        // TODO: draft state or publish metadata is there because there is really bad and dangerous typecasting when retrieving data from room - https://linear.app/supernova-io/issue/RCT-2979/fe-tech-debt-or-improve-usage-of-documentation-items-taken-from-the
        this.draftState = null;
        this.publishMetadata = null;
        this.id = model.id;
        this.persistentId = model.persistentId;
        this.type = model.type;
        this.configuration = new DocumentationLegacyItemConfiguration(model.configuration);
        this.slug = model.slug;
        this.userSlug = (_a = model.userSlug) !== null && _a !== void 0 ? _a : null;
        this.title = model.title;
        this.createdAt = model.createdAt ? new Date(model.createdAt) : null;
        this.updatedAt = model.updatedAt ? new Date(model.updatedAt) : null;
        this.isPrivate = Boolean((_b = model.configuration) === null || _b === void 0 ? void 0 : _b.isPrivate);
        this.isHidden = Boolean((_c = model.configuration) === null || _c === void 0 ? void 0 : _c.isHidden);
    }
}
